<script setup lang="ts">
import { defineProps } from 'vue'
import IconTriangle from '@/components/icon/IconTriangle.vue'

interface Props {
  color?: string
  href: string
  blank?: boolean
  text: string
}
const props = defineProps<Props>()
</script>

<template>
  <div :class="['btn', props.color ? `-${props.color}` : '']">
    <template v-if="props.blank">
      <a
        :href="props.href"
        :target="props.blank ? '_blank' : '_self'"
        :rel="props.blank ? 'noopener noreferrer' : ''"
      >
        <span class="btn-inner">
          {{ props.text }}
          <IconTriangle />
        </span>
        <div class="bg" />
      </a>
    </template>
    <template v-else>
      <RouterLink :to="props.href">
        <span class="btn-inner">
          {{ props.text }}
          <IconTriangle />
        </span>
        <div class="bg" />
      </RouterLink>
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/inc/_mixin';
@import '@/assets/scss/inc/_function';

.btn {
  &.-sub {
    a {
      .btn-inner {
        background: var(--pink);
      }
    }
  }

  a {
    --gap: 5px;
    display: block;
    @include fz(20, true);
    font-weight: 900;
    font-family: var(--ff-mplus);
    color: var(--navy);
    position: relative;
    @include media(sm) {
      --gap: #{vw(5)};
    }
    @include ahover {
      .btn-inner {
        background: var(--btn-active);
        translate: var(--gap) var(--gap);
      }
    }

    .bg {
      position: absolute;
      inset: var(--gap) 0 0 var(--gap);
      background: var(--navy);
      width: calc(100% - var(--gap));
      height: 100%;
      border-radius: var(--radiusSm);
      z-index: 1;
    }

    .btn-inner {
      min-height: 64px;
      padding: 8px 24px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: var(--radiusSm);
      border: solid 1px currentColor;
      background: linear-gradient(180deg, var(--beige), var(--beige));
      width: calc(100% - var(--gap));
      transition: background var(--ease) var(--time),
        translate var(--ease) var(--time);
      z-index: 2;
      position: relative;

      @include media(sm) {
        min-height: vw(64);
        padding: vw(4) vw(24);
      }
    }

    svg {
      @include media(sm) {
        width: vw(14);
      }
    }
  }
}
</style>
